import React, { useState } from 'react';

import CRMApi from '../../../Api/CRM/CRMApi';
import User from '../../../Api/Models/User';
import useGlobalState from '../../GlobalStateContext';
import CasinoBonusHistoryTable from '../../casino/elements/User/Show/CasinoBonusHistoryTable';
import CasinoDetailedBreakdown from '../../casino/elements/User/Show/CasinoDetailedBreakdown';
import CasinoTransactionsTable from '../../casino/elements/User/Show/CasinoTransactionsTable';
import { IS_CASINO_ENABLED } from '../../helpers/Constants';
import { ROLE } from '../../helpers/Permissions';
import useNumberParams from '../../hooks/useNumberParams';
import useOnce from '../../hooks/useOnce';
import DepositsList from '../deposit/DepositsList';
import TicketsList from '../ticket/TicketsList';
import WithdrawalsList from '../withdrawal/WithdrawalsList';

import UserActivity from './UserActivity';
import UserDepositsChart from './UserDepositsChart';
import UserDetails from './UserDetails';
import UserDetailsShort from './UserDetailsShort';
import UserLoginLogs from './UserLoginLogs';
import UserMetrics from './UserMetrics';

export default function UserShow() {
    const { id } = useNumberParams();
    const [user, setUser] = useState<User>({} as User);
    const url = `/crea/api/user/${id}`;
    const { loggedAdmin } = useGlobalState();

    useOnce(() => CRMApi.users.getById(id).then(setUser));

    if (loggedAdmin.hasRole(ROLE.AFFILIATE_OWNER)) {
        return (
            <>
                <UserMetrics url={`/crea/api/metrics/${id}`} />
                <UserDetailsShort user={user} />
                <TicketsList source="user" relatedId={id} short />
                <DepositsList source="user" relatedId={id} short addManualButton />
                {IS_CASINO_ENABLED && <CasinoTransactionsTable userId={id} />}
            </>
        );
    }

    return (
        <>
            <UserDepositsChart url={`${url}/deposits_weekly`} minDate={user.first_time_deposit_date} />
            <UserDetails user={user} />
            <UserActivity userId={id} />
            <TicketsList source="user" relatedId={id} />
            <WithdrawalsList source="user" relatedId={id} addManualButton />
            <DepositsList source="user" relatedId={id} addManualButton />
            {loggedAdmin.isSuperAdmin() && <UserLoginLogs userId={id} />}
            {IS_CASINO_ENABLED && (
                <>
                    <CasinoDetailedBreakdown userId={id} />
                    <CasinoTransactionsTable userId={id} />
                    <CasinoBonusHistoryTable userId={id} />
                </>
            )}
        </>
    );
}
